module.exports = __webpack_public_path__ + "static/media/kn95.23668f98.jpg";